// extracted by mini-css-extract-plugin
module.exports = {"label":"fieldLabel_label__BIVsf","notFound":"fieldLabel_notFound__2j7E-"};